<div class="container" *ngIf="isTranslationLoaded">
  <qai-inner-wrap>
    <h2 class="heading">{{ "leaderboard.LEADERBOARD" | transloco }}</h2>

    <div class="leaderboard-header-container">
      <qai-field [label]="'leaderboard.PRACTICE_ASSIGNMENT' | transloco">
        <qai-floating-select
          [options]="assignmentOptions"
          [value]="selectedAssignment"
          [placeholder]="getAssignmentPlaceholder()"
          [placement]="'below-start'"
          [offset]="4"
          [maxWidth]="'var(--select-max-width)'"
          [shape]="'rectangle'"
          [disabled]="assignmentOptions.length === 0"
          (valueChange)="valueChange({ value: $event, source: 'assignment' })"
          class="select-field"
        ></qai-floating-select>
      </qai-field>

      <qai-field [label]="'leaderboard.SIMULATION' | transloco">
        <qai-floating-select
          [options]="simulationOptions"
          [value]="selectedSimulation"
          [placeholder]="getSimulationPlaceholder()"
          [placement]="'below-start'"
          [offset]="4"
          [maxWidth]="'var(--select-max-width)'"
          [shape]="'rectangle'"
          [disabled]="!selectedAssignment || simulationOptions.length === 0"
          (valueChange)="valueChange({ value: $event, source: 'simulation' })"
          class="select-field"
        ></qai-floating-select>
      </qai-field>
    </div>
  </qai-inner-wrap>
</div>
